module.exports = __webpack_public_path__ + "static/media/Family.21e9baf4.svg";